//* 可视化图形
import { GeneExpression, type GeneExpressionOption } from "@cya/gene-expression";
//* 组件属性
import type { ModuleProps } from "../index";
import { useOptions } from "./options";

export const useComposable = (define: ModuleProps) => {
    //* 插件
    const route = useRoute();
    //* 配置项
    const options = useOptions();

    //* 静态属性
    const vars: { data: Ref<{ [name: string]: GeneExpressionOption }>; canvas?: GeneExpression } = { data: shallowRef({}) };
    //* 响应式变量
    const refs = {
        mode: ref<string>(""), //* 排序模式
        exist: ref<boolean>(true), //* 页面状态配置
        loading: ref<boolean>(true), //* 内置加载器
    };

    //* 节点
    const nodes = {
        canvas: useTemplateRef<HTMLDivElement>("canvas"),
    };

    //* 函数列表
    const methods = {
        //* 初始化函数
        render: (data?: GeneExpressionOption) => {
            //* 数据初始化
            refs.loading.value = false;
            refs.mode.value = "group";
            if (data?.data?.length) {
                vars.data.value[refs.mode.value] = data;
            }

            //* 销毁残留的可视化图形
            vars.canvas?.destroy();
            if (data && nodes.canvas.value) {
                vars.canvas = new GeneExpression(
                    nodes.canvas.value,
                    Object.assign(JSON.parse(JSON.stringify(data)), { tip: { zIndex: 66 }, resize: true })
                );
            }
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 排序模式切换函数
        mode: () => {
            //* 数据预取
            const response = vars.data.value[refs.mode.value];
            if (response) vars.canvas?.render(response.data, response.captions);
            else {
                refs.loading.value = true;
                api.frontend("/api/gene/expression", {
                    data: { id: route.params.id, sort: refs.mode.value, type: define.type },
                    finally: () => (refs.loading.value = false),
                    success: (response) => {
                        if (response?.data?.length) {
                            //* 数据初始化
                            vars.data.value[refs.mode.value] = response;
                            //* 渲染函数
                            vars.canvas?.render(response.data, response.captions);
                        }
                    },
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        option: computed(() => {
            if (define.type == "cell") return options.cell;
            else {
                return options.tissue;
            }
        }),
    };

    return { vars, refs, nodes, methods, computeds };
};
